import React, { Fragment } from 'react';
import { ScatterChart, Scatter, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, ZAxis, Label, Legend } from 'recharts';

const ActiveVSPassive = ({ data }) => {

  // Manipulate active data
  // Filter only for the active types.
  const filteredData = data.filter((d) => { return d.type === "ACTIVE" })
  // Then rename the date items in the array.
  const mappedData = filteredData.map((d) => { return { "x": d.abs_5_year_ret_pctl, "y": d.total_5_year_ret, "z": 50 }; });

  // Manipulate passive data.
  const passiveDataItem = data.find((d) => { return d.type === "PASSIVE05" });
  const passivePoint1 = { "x": 0, "y": passiveDataItem.total_5_year_ret, "z": 1 };
  const passivePoint2 = { "x": 100, "y": passiveDataItem.total_5_year_ret, "z": 1 };
  const passiveDataSet = [passivePoint1, passivePoint2];

  return (
    <Fragment>
      <h3>Percentiles for Total Returns of Active vs Passive</h3>
      <ResponsiveContainer width="100%" height={400}>
        <ScatterChart
          margin={{
            top: 20,
            right: 20,
            bottom: 20,
            left: 20,
          }}
        >
          <CartesianGrid />
          <XAxis type="number" dataKey="x" name="Percentiles" unit=""><Label value="Percentiles"  offset={-10} position="insideBottomLeft"/></XAxis>
          <YAxis type="number" dataKey="y" name="Absolute Return" unit="%"><Label value="Absolute Return" angle={-90} offset={10} position="left" /></YAxis>
          <ZAxis type="number" dataKey="z" range={[0, 75]} name="Blob Size" unit="blobs" />
          <Legend/>
          <Scatter name="5 Year Active" data={mappedData} fill="black" />
          <Scatter name="5 Year Passive" data={passiveDataSet} line={{ stroke: 'grey', strokeWidth: 4 }} fill="grey" />
        </ScatterChart>
      </ResponsiveContainer>
    </Fragment>
  );
};

export default ActiveVSPassive;